import React from 'react'
import PropTypes from 'prop-types'

const LedgerIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="20" fill="#FFF" rx="2" />
      <g fill="#007AFA">
        <path d="M16 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 5h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zM16 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 9h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zM16 13a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM4 13h9a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2z" />
      </g>
    </g>
  </svg>
)

LedgerIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default LedgerIcon
